import {Carousel} from 'react-bootstrap';

const carouselItems = [
    '/assets/images/LandingPage/AlumniSection/Mido.jpg',
    '/assets/images/LandingPage/Carousel/4-Key-Steps-to Conducting-Effective Market-Research.png',
    '/assets/images/LandingPage/AlumniSection/Jemima.jpg',
    '/assets/images/LandingPage/Carousel/Customer-Segments-Infographic.png',
    '/assets/images/LandingPage/AlumniSection/James.jpg',
    '/assets/images/LandingPage/Carousel/The-Traits-of-an-Entrepreneur.png',
];

export const HeroSectionCarousel = () => {

    return (
        <div className="HeroSection--carousel">
            <Carousel style={{borderRadius: '10px'}}>
                {carouselItems.map((carouselItem, index) => (
                    <Carousel.Item key={index}>
                        <img
                            alt="carousel--img"
                            className="HeroSection--carousel--img"
                            src={carouselItem}
                        />
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};